<template>
  <div class="formula-input">
    <input
      v-model="expression"
      type="text"
      :class="[{ error: !isValidExp }]"
      placeholder="( A + B ) / C"
    />
    <div class="options">
      <ul class="property-list">
        <li v-for="option in propOptions" :key="option.id">
          <span class="text-icon">{{ option.keyCode }}</span>
          <div class="property-details">
            <h4>{{ option.name }}</h4>
            <span>{{ option.entity_model_name }}</span>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    options: Array,
    value: String,
    isvalidExp: false,
  },
  data() {
    return {
      isValidExp: false,
      exp: "",
      variables: [],
    };
  },
  computed: {
    expression: {
      get() {
        return this.value ? this.value.toUpperCase() : "";
      },
      set(value) {
        this.$emit("input", value.toUpperCase());
        const variableIds = [];
        let replaceVar = [];

        // pattern to match the nearest function
        const nearestPattern = /^NEAREST\(([A-Z]),.*\)/;
        const result = value.match(nearestPattern);

        // check if the nearest function is valid for the expression
        if (result && result.length > 0 && result[1]) {
          let char = result[1];
          // check for the variable
          if (/[A-Z]/.test(char)) {
            let variable = this.propOptions.find(
              (item) => item.keyCode === char
            );
            if (variable) {
              variableIds.push(variable.id);
              replaceVar = [
                "NEAREST",
                "(",
                `\${${variable.id}}`,
                ",",
                "HUBS",
                ")",
              ];
              this.isValidExp = true;
            } else {
              this.isValidExp = false;
            }
          } else {
            this.isValidExp = false;
          }
        } else {
          // remove spaces and split by character
          let expr = value.split(" ").join("").split("");
          this.isValidExp = true;
          replaceVar = expr.map((char) => {
            // check if the character is a varaible
            if (!/[A-Z]/.test(char)) return char;
            // find the property associated with the keycode
            let variable = this.propOptions.find(
              (item) => item.keyCode === char
            );
            // if variable is present
            if (variable) {
              if (!variableIds.includes(variable.id)) {
                variableIds.push(variable.id);
              }
              return `\${${variable.id}}`;
            } else {
              this.isValidExp = false;
              return char;
            }
          });
        }

        let representation = [...replaceVar];
        variableIds.forEach((item, index) => {
          replaceVar.forEach((letter, letterIndex) => {
            if (letter === `\${${item}}`) {
              replaceVar[letterIndex] = String.fromCharCode(index + 65);
              representation[letterIndex] = this.options.find(
                (option) => option.id === item
              ).name;
            }
          });
        });

        this.variables = variableIds;
        this.exp = replaceVar.join("");
        this.$emit("eval", {
          isValid: this.isValidExp,
          variables: this.variables,
          expression: this.exp,
          representation: representation.join(""),
        });
      },
    },
    propOptions() {
      return this.options.slice(0, 26).map((prop, index) => {
        return {
          ...prop,
          keyCode: String.fromCharCode(index + 65),
        };
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.formula-input {
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;

  .options {
    background: var(--color-secondary);
    border: 1px solid var(--border-color);
    border-radius: 5px;
    max-height: 300px;
    overflow-y: auto;
    position: absolute;
    width: 100%;
    top: 45px;
    display: none;

    .property-list {
      list-style-type: none;
      margin: 0;
      padding: 0;
      display: flex;
      flex-direction: column;

      li {
        display: flex;
        align-items: center;
        padding: 10px;

        .text-icon {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 30px;
          height: 30px;
          background: var(--color-default-background);
          font-size: 1.3em;
          border-radius: 50%;
          padding: 5px;
          border-bottom: 1px solid var(--border-color);
          color: var(--color-primary);

          &:last-child {
            border: 0;
          }
        }

        .property-details {
          display: flex;
          flex-direction: column;
          margin-left: 10px;

          span {
            font-size: 0.9em;
            opacity: 0.7;
          }
        }
      }
    }
  }

  input:focus + .options {
    display: flex !important;
  }

  input:focus.error {
    border: 1px solid var(--color-error) !important;
  }
}
</style>
